import { Typography, Select, MenuItem, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { jbColors } from 'theme/jbColors';

interface DocumentDistributionLanguageSelectProps {
  language: string;
  languages: string[];
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
}

const DocumentDistributionLanguageSelect = ({
  language,
  languages,
  setLanguage,
}: DocumentDistributionLanguageSelectProps) => {
  useEffect(() => {
    if (languages) {
      setLanguage((prev) => (languages.includes(prev) ? prev : 'EN'));
    }
  }, [languages, setLanguage]);

  return (
    <Grid container sx={{ mt: 1, mb: 1 }} data-testid={'document-distribution-select'}>
      <Typography variant="body2" sx={{ color: jbColors.core.reflexBlue[100] }}>
        Select language to distribute the document:
      </Typography>
      <Select
        value={language}
        onChange={(e) => {
          setLanguage(e.target.value);
        }}
        sx={{
          mt: 0.5,
          width: '100%',
          '& .MuiInputBase-root': {
            border: 'none',
            padding: 0,
            display: 'flex',
            color: 'black',
          },
          '& .MuiFormControl-root': {
            color: 'black',
          },
          '& .MuiInputBase-input': {
            border: 'none',
            padding: '8px',
            color: 'black',
          },
          '& .MuiOutlinedInput-input': {
            border: 'none',
            color: 'black',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',

            color: 'black',
          },
        }}
      >
        {languages?.length > 0 &&
          languages?.map((value) => {
            return (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            );
          })}
      </Select>
    </Grid>
  );
};

export default DocumentDistributionLanguageSelect;
